import React from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';
import type { Counter } from '@swf/core/types/Notification';

interface Props {
  counter: keyof Counter;
}

const CounterBadge: React.FC<Props> = ({ counter }) => {
  const counters = useSelector(select.notification.getCounters);

  return <span>{counters[counter]}</span>;
};

export default CounterBadge;
